import { useEffect, useState } from 'react';
import SliderWithInput from '../ChartOptions/SliderWithInput';
import ColorPickerPopover from './ColorPickerObjects';
import { useDispatch } from 'react-redux';
import { updateAllTileBorder } from '../../redux/TabTile/TabActions';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux';

function BorderControles({ tabId, iconColor }: { tabId: number; iconColor?: string }) {
  const {
    tabState: { tabs },
  } = useSelector((state: RootState) => state);
  const {
    allTileBorder: { borderProperties },
  } = tabs[tabId];

  const [borderColorAnchor, setBorderColorAnchor] = useState<HTMLElement | null>(null);
  const [currentColor, setCurrentColor] = useState<string>(borderProperties?.color);
  const [borderWidth, setBorderWidth] = useState<number>(borderProperties?.width);
  const [borderRadius, setBorderRadius] = useState<number>(borderProperties?.borderRadius);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      updateAllTileBorder({
        tabId,
        borderProperties: { color: currentColor, width: borderWidth, borderRadius },
      }),
    );
  }, [currentColor, borderWidth, borderRadius]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', marginTop: '-5px' }}>
      {/* Border Color */}
      <div
        className="optionDescription"
        style={{
          display: 'flex',
          alignItems: 'start',
          flexDirection: 'column',
          justifyContent: 'center',
          marginTop: 0,
          paddingTop: 0,
          color: iconColor,
        }}
      >
        Border Color
        <div
          style={{
            marginTop: 2,
            width: 100,
            maxWidth: '30%',
            height: '1.25rem',
            backgroundColor: currentColor,
            border: '2px solid darkgray',
            borderRadius: 4,
            cursor: 'pointer',
          }}
          onClick={(e) => setBorderColorAnchor(e.currentTarget)}
        />
      </div>
      <ColorPickerPopover
        isOpen={Boolean(borderColorAnchor)}
        anchorEl={borderColorAnchor}
        onClose={() => setBorderColorAnchor(null)}
        currentColor={currentColor}
        onColorChange={(color) => {
          setCurrentColor(color);
        }}
      />

      {/* Border Width */}
      <div>
        <div
          className="optionDescription"
          style={{ marginBottom: '1px', marginTop: 0, color: iconColor }}
        >
          Border Width
        </div>
        <SliderWithInput
          percent={false}
          sliderValue={borderWidth}
          sliderMinMax={{ min: 1, max: 20, step: 1 }}
          changeValue={(value: number) => setBorderWidth(value)}
        />
      </div>

      {/* Border Radius */}
      <div>
        <div
          className="optionDescription"
          style={{ marginBottom: '1px', marginTop: 0, color: iconColor }}
        >
          Border Radius
        </div>
        <SliderWithInput
          percent={false}
          sliderValue={borderRadius}
          sliderMinMax={{ min: 1, max: 20, step: 1 }}
          changeValue={(value: number) => setBorderRadius(value)}
        />
      </div>
    </div>
  );
}

export default BorderControles;
